import { useNavigate, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { XCircle, RefreshCw, Home } from 'lucide-react'
import { AuthLayout } from '@/components/AuthLayout'
import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'

export function PaymentFailurePage() {
  const { t } = useTranslation(['payments', 'common'])
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const merchantRef = searchParams.get('ref')
  const errorType = searchParams.get('error')

  const getErrorMessage = () => {
    switch (errorType) {
      case 'not_found':
        return t('failure.notFound')
      case 'verification':
        return t('failure.verification')
      default:
        return t('failure.message')
    }
  }

  return (
    <AuthLayout>
      <Card>
        <CardContent className="py-10 text-center space-y-6">
          <div className="rounded-full bg-destructive/10 p-4 w-fit mx-auto">
            <XCircle className="h-12 w-12 text-destructive" />
          </div>

          <div>
            <h1 className="text-2xl font-bold text-destructive mb-2">{t('failure.title')}</h1>
            <p className="text-muted-foreground">{getErrorMessage()}</p>
          </div>

          {merchantRef && (
            <div className="bg-muted rounded-lg p-4">
              <p className="text-xs text-muted-foreground mb-1">{t('reference')}</p>
              <p className="font-mono font-medium">{merchantRef}</p>
            </div>
          )}

          <div className="space-y-3">
            <Button className="w-full" onClick={() => navigate('/payments/checkout')}>
              <RefreshCw className="h-4 w-4 mr-2" />
              {t('tryAgain')}
            </Button>
            <Button variant="outline" className="w-full" onClick={() => navigate('/')}>
              <Home className="h-4 w-4 mr-2" />
              {t('backToHome', { ns: 'common' })}
            </Button>
          </div>

          <p className="text-xs text-muted-foreground">{t('failure.contactSupport')}</p>
        </CardContent>
      </Card>
    </AuthLayout>
  )
}
